/**
 * 小红书爆款 - 数据可视化模板 Compositions
 *
 * 包含：收入对比、时间分配、成长数据等数据驱动型模板
 */

import { Composition } from 'remotion';
import { XHSDataVisualization } from './XHSDataVisualization';

const timeAllocationExample = {
  hookNumber: '168小时',
  hookLabel: '每周总时间',
  hookSubtext: '你真的利用好了吗？',
  chartData: [
    { label: '睡眠', value: 56, color: '#A855F7' },
    { label: '工作', value: 40, color: '#EF4444' },
    { label: '通勤', value: 10, color: '#F59E0B' },
    { label: '学习', value: 14, color: '#22C55E' },
    { label: '娱乐', value: 21, color: '#3B82F6' },
    { label: '其他', value: 27, color: '#64748B' },
  ],
  trends: [
    {
      title: '有效利用',
      currentValue: '54 小时',
      change: '+32%',
      trend: 'up' as const,
    },
    {
      title: '低效时间',
      currentValue: '23 小时',
      change: '-15%',
      trend: 'down' as const,
    },
  ],
  conclusion: '时间就是金钱',
  actionText: '关注我，高效人生',
};

export const XHSDataVisualizationCompositions = () => {
  return (
    <>
      <Composition
        id="XHS-Viral-TimeAllocation"
        component={XHSDataVisualization}
        durationInFrames={600}
        fps={30}
        width={1080}
        height={1920}
        defaultProps={timeAllocationExample}
      />
    </>
  );
};
